import { Autosuggest, IconSearch } from 'braid-design-system';
import { useEffect } from 'react';

import {
  useSuggestions,
  type Suggestions,
} from 'src/components/useSuggestions/useSuggestions';
import type { Partner } from 'src/types';
import { analytics } from 'src/utils/analytics/analytics';
import { useQueryHistory } from 'src/utils/hooks/useQueryHistory';
import { slugify } from 'src/utils/slugify';

interface Props {
  disabled: boolean;
  groupedSuggestions: Suggestions<Partner>;
}

export const SearchFilter = ({
  disabled = false,
  groupedSuggestions,
}: Props) => {
  const { value, set, delete: qhDelete } = useQueryHistory('name');
  const { searchValue, setSearchValue, clearSearchValue, suggestions } =
    useSuggestions(groupedSuggestions);

  const onSearchValueChange = (newSuggestVal: any) => {
    setSearchValue(newSuggestVal);

    // will only have .value when a suggestion has been selected.
    const selectedPartner = newSuggestVal.value;
    if (selectedPartner) {
      set(selectedPartner.name);
      analytics.link(
        `search-filter-${
          selectedPartner.slug || slugify({ str: selectedPartner.name })
        }`,
      );
    }
  };

  const clearSearch = () => {
    clearSearchValue();
    qhDelete();
  };

  /**
   * Update the search value when the query changes.
   * This keeps the search value up to date when using browser back/forward buttons.
   */
  useEffect(() => {
    setSearchValue({ text: value || '' });
  }, [value, setSearchValue]);

  return (
    <Autosuggest
      id="search-filter"
      disabled={disabled}
      icon={<IconSearch />}
      label="Search by partner"
      value={searchValue}
      onChange={onSearchValueChange}
      onClear={clearSearch}
      suggestions={suggestions}
    />
  );
};
